import Input from "components/inputs";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const Rules = ({ onChangeRules, handleRulesClick }) => {
  const { t } = useTranslation();
  const rules = (
    <>
      {t("content")}
      <Link
        onClick={() => handleRulesClick()}
        className="text-blue-0 hover:text-blue-0"
      >
        {" "}
        {t("rules")}{" "}
      </Link>
      {t("acceptRules")}
    </>
  );

  return (
    <div className="mb-3 ">
      <Input
        onChange={onChangeRules}
        name="rules"
        type="checkbox"
        checkboxContent={rules}
      />
    </div>
  );
};
export default Rules;
